var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageOrganizationDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00293 26.5V4C6.00293 3.6625 6.00293 3.3125 6.09043 2.975C6.16694 2.63828 6.33634 2.32977 6.5794 2.08451C6.82245 1.83924 7.12942 1.66705 7.46543 1.5875C7.82793 1.5 9.41543 1.5 9.75293 1.5H18.5029C18.8404 1.5 19.1904 1.5 19.5279 1.5875C19.8646 1.66401 20.1732 1.83341 20.4184 2.07647C20.6637 2.31952 20.8359 2.62649 20.9154 2.9625C21.0029 3.3125 21.0029 3.6625 21.0029 4V26.5H6.00293Z",
    stroke: "#C3C3C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00278 16.5V24C1.00278 25.375 2.12778 26.5 3.50278 26.5H6.00278V14H3.50278C3.16528 14 2.81528 14 2.47778 14.0875C2.14028 14.175 1.82778 14.3375 1.57778 14.5875C1.34028 14.825 1.17778 15.1375 1.09028 15.475C1.01972 15.8119 0.990335 16.1561 1.00278 16.5Z",
    stroke: "#C3C3C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5279 10.3375C24.1911 10.2669 23.8469 10.2375 23.5029 10.25H21.0029V26.5H23.5029C24.166 26.5 24.8019 26.2366 25.2707 25.7677C25.7395 25.2989 26.0029 24.663 26.0029 24V12.75C26.0029 12.4 26.0029 12.0625 25.9154 11.725C25.8279 11.3875 25.6654 11.075 25.4154 10.825C25.1779 10.5875 24.8654 10.425 24.5279 10.3375Z",
    stroke: "#C3C3C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0024 6.5H16.0024",
    stroke: "#C3C3C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0024 11.5H16.0024",
    stroke: "#C3C3C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0024 16.5H16.0024",
    stroke: "#C3C3C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0024 21.5H16.0024",
    stroke: "#C3C3C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageOrganizationDefault);
export default __webpack_public_path__ + "static/media/Manage Organization _ Default.a48f39ab1261ba40238c9c4b95183296.svg";
export { ForwardRef as ReactComponent };